import React from 'react';

import clsx from 'clsx';
import { useFeatures } from '@atc/features';
import { Button, Glyphicon, SubHeading, Text } from 'reaxl';

function Title({ onClick = () => {}, enableTitleLink = false, uiContext = 'default', showIcon = true }) {
    const {
        srp_wallet_grid_update: [
            enableUpdatedWalletGrid,
            { with_kbb_grid_upgrade: withKbbGridUpdate, without_kbb_logo: withoutKbbLogo },
        ],
        global_kbb_branded_wallet: [enableKbbBrandedWallet, { hide_kbb_branding: hideKbbBranding }],
    } = useFeatures(['srp_wallet_grid_update', 'global_kbb_branded_wallet']);

    const isBasicGrid = uiContext === 'basic';
    let glyphClassNames = '';

    if (isBasicGrid) {
        glyphClassNames = 'text-accent';
    }

    if (withKbbGridUpdate) {
        glyphClassNames = 'wallet-grid-hdr-blue';
    }

    if (uiContext === 'default' || isBasicGrid) {
        const sharedClasses = 'display-inline-block';
        const textSizeClassName = isBasicGrid ? 'text-size-500' : '';
        const kbbTextColor = withKbbGridUpdate ? 'wallet-grid-hdr-blue' : '';

        return (
            <SubHeading level="4">
                <Button
                    className={clsx({ 'cursor-pointer': !isBasicGrid }, 'user-icon display-flex align-items-center')}
                    bsStyle="text"
                    onClick={onClick}
                >
                    {!isBasicGrid && !hideKbbBranding && (
                        <React.Fragment key="title-my-wallet-grid-key">
                            <span className={clsx(sharedClasses, kbbTextColor)}>
                                Kelley Blue Book
                                <sup>®</sup>
                            </span>
                            <span className={clsx(sharedClasses, kbbTextColor, 'margin-left-2 margin-right-3')}>|</span>
                        </React.Fragment>
                    )}
                    <Glyphicon
                        className={clsx('margin-right-2 align-self-center', glyphClassNames)}
                        glyph="wallet"
                        style={{ marginBottom: '2px' }}
                    />
                    <span
                        className={clsx(
                            { '': enableUpdatedWalletGrid },
                            kbbTextColor,
                            textSizeClassName,
                            sharedClasses
                        )}
                    >
                        My Wallet
                    </span>
                </Button>
            </SubHeading>
        );
    }

    if (enableKbbBrandedWallet) {
        const heading = (
            <>
                <Glyphicon
                    className="text-size-500"
                    glyph="wallet"
                />{' '}
                <Text size={500}>My Wallet</Text>
                {!hideKbbBranding && (
                    <>
                        {' '}
                        <Text
                            size={300}
                            weight="light"
                        >
                            by Kelley Blue Book
                            <span className="text-valign-super text-size-100">&#174;</span>
                        </Text>
                    </>
                )}
            </>
        );

        return (
            <>
                <div
                    className={clsx('margin-vertical-4', {
                        inverted: enableTitleLink,
                    })}
                >
                    {enableTitleLink ? (
                        <Button
                            bsStyle="text"
                            onClick={onClick}
                        >
                            {heading}
                        </Button>
                    ) : (
                        heading
                    )}
                </div>
                {!hideKbbBranding && showIcon && !withoutKbbLogo && (
                    <img
                        height="31"
                        width="130"
                        src="https://www.kbb.com/cm-api/content/static/img/partner/kbb/KBB_Logo_Rev_White_RGB_Small.svg"
                        className="margin-left-auto margin-right-5"
                        alt=""
                    />
                )}
            </>
        );
    }
    return <>My Wallet</>;
}
export default Title;
